import { render, staticRenderFns } from "./CommentsFilter.vue?vue&type=template&id=da529434&"
import script from "./CommentsFilter.vue?vue&type=script&lang=js&"
export * from "./CommentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports